<template>
  <div>
    <v-container class="pl-10 ml-0" v-show="loading">
      <Home ref="Home"></Home>
    </v-container>
    <PageLoadingProgress ref="PageLoadingProgress"></PageLoadingProgress>
  </div>
</template>

<script>
import Home from "@/components/mileage/home/Home.vue";
import PageLoadingProgress from "@/components/common/PageLoadingProgress.vue";

export default {
  data: () => {
    return {
      loading: false,
    };
  },
  methods: {
    loadCompleted: function() {
      this.$refs.PageLoadingProgress.hide();
      this.loading = true;
    },
  },
  components: {
    Home,
    PageLoadingProgress,
  },
  created: function() {},
  mounted: async function() {
    this.$refs.PageLoadingProgress.show();
  },
};
</script>
